import { createNgReactBridgeDirective } from '../../react-bridge'
import { DetailTags } from '../../../legacy-design-system/detail-tags/detail-tags'

export const detailTags = createNgReactBridgeDirective(
  'reactDetailTags',
  [],
  DetailTags,
  ['hasEditRole', 'tags', 'deleteTag']
)
